import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EditBarMobile } from './edit-bar-mobile';
import { EditBarWeb } from './edit-bar-web';

type EditBarProps = {
  displayNewsButtons: boolean;
  displayBackButton: boolean;
  canEditOnMobile?: boolean;
  displayManageUpdates?: boolean;
};
export const EditBar: React.FC<EditBarProps> = ({
  displayNewsButtons,
  displayBackButton,
  canEditOnMobile = false,
  displayManageUpdates = false,
}) => {
  const { pageContext } = usePageContext();

  if (!pageContext.isEditor) {
    return null;
  }

  return (
    <>
      <EditBarMobile
        displayBackButton={displayBackButton}
        canEditOnMobile={canEditOnMobile}
        displayManageUpdates={displayManageUpdates}
      />
      <EditBarWeb
        displayNewsButtons={displayNewsButtons}
        displayBackButton={displayBackButton}
      />
    </>
  );
};
